module.exports = "./img/5d6c7e3ae12bb08b11d8869a9db93bf0.jpg";